var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"file",staticStyle:{"visibility":"hidden"},attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }